import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/warehouse-receiving/stored/$goodsReceiptId/_layout/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/warehouse-receiving/stored/$goodsReceiptId/built-pallets",
      params: { goodsReceiptId: params.goodsReceiptId },
    })
  },
})
